import React from 'react';

import type { ILead } from 'src/services/api';
import ExpandableItem from 'src/components/lead-sidebar/LeadSidebarExpandableItem';
import { FlexColumn } from 'src/components/flex';
import FactRow from 'src/components/lead-sidebar/FactRow';
import { getDisplayedSmartFields } from 'src/components/lead-sidebar/displayed-smart-fields';

type Props = {
    lead: ILead;
};

export default function SmartFields({ lead }: Props) {
    const smartFields = getDisplayedSmartFields(lead);

    if (smartFields.length === 0) {
        return null;
    }

    return (
        <ExpandableItem title="Smart Fields" defaultExpanded={false}>
            <FlexColumn rowGap={1.5} pb={1}>
                {smartFields.map(({ key, label, value }) => (
                    <FactRow key={key} label={label} value={value} factKey={`smart-${key}`} />
                ))}
            </FlexColumn>
        </ExpandableItem>
    );
}
